import { Alert, alertClasses } from '@mui/material';
import { styled } from '@mui/system';

export const CustomAlert = styled(Alert)(({ theme: { palette } }) => ({
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
  display: 'flex',
  alignItems: 'center',
  padding: 8,
  paddingRight: 20,
  maxWidth: 328,
  borderWidth: 1,
  borderStyle: 'solid',

  [`.${alertClasses.icon}`]: {
    padding: 10,
    borderRadius: 4,
    marginRight: 20,
  },
  [`&.${alertClasses.standardSuccess}`]: {
    background: palette.success.light,
    borderColor: palette.success.main,
    color: palette.text.primary,

    [`.${alertClasses.icon}`]: {
      background: palette.success.dark,
    },
  },
  [`&.${alertClasses.standardWarning}`]: {
    background: palette.warning.light,
    borderColor: palette.warning.main,
    color: palette.text.primary,

    [`.${alertClasses.icon}`]: {
      background: palette.warning.dark,
    },
  },
  [`&.${alertClasses.standardError}`]: {
    background: palette.error.light,
    borderColor: palette.error.main,
    color: palette.text.primary,

    [`.${alertClasses.icon}`]: {
      background: palette.error.dark,
    },
  },

  [`.${alertClasses.message}`]: {
    padding: 0,
  },
  [`.${alertClasses.action}`]: {
    padding: 0,
    marginLeft: 16,
  },
}));
